import { KeyEnum, DisplayMapper, OptionMapper } from '../OptionConstant';
const appApplyStatus = {};
for (let name in KeyEnum.AppApplyStatus) {
  appApplyStatus[name] = parseInt(KeyEnum.AppApplyStatus[name], 10);
}

export default {
  calculateAppPlatform(plateform) {
    let appPlatform = OptionMapper.APPLY_PLATFORM;
    plateform = parseInt(plateform);
    let display = [];
    appPlatform.forEach(item => {
      let value = parseInt(item.value);
      if ((value & plateform) === value) {
        display.push(item.label);
      }
    });
    return display.join('，');
  },
  calculateStyle(status, styleClazz) {
    status = parseInt(status);
    // 不存在3则默认用fail的style
    if ((status & appApplyStatus.STOP) === appApplyStatus.STOP) {
      return styleClazz[3] || styleClazz[2];
    }
    if ((status & appApplyStatus.FORMAL_AUTH_OVER) === appApplyStatus.FORMAL_AUTH_OVER) {
      return styleClazz[0];
    }
    if ((status & appApplyStatus.FORMAL_VERIFY_FAIL) === appApplyStatus.FORMAL_VERIFY_FAIL) {
      return styleClazz[2];
    }
    if ((status & appApplyStatus.FORMAL_VERIFY_SUCCESS) === appApplyStatus.FORMAL_VERIFY_SUCCESS) {
      return styleClazz[1];
    }
    if ((status & appApplyStatus.FORMAL_VERIFYING) === appApplyStatus.FORMAL_VERIFYING) {
      return styleClazz[0];
    }
    if ((status & appApplyStatus.AUTH_OVER) === appApplyStatus.AUTH_OVER) {
      return styleClazz[0];
    }
    if ((status & appApplyStatus.VERIFY_FAIL) === appApplyStatus.VERIFY_FAIL) {
      return styleClazz[2];
    }
    if ((status & appApplyStatus.VERIFY_SUCCESS) === appApplyStatus.VERIFY_SUCCESS) {
      return styleClazz[1];
    }
    if ((status & appApplyStatus.VERIFYING) === appApplyStatus.VERIFYING) {
      return styleClazz[0];
    }
    if ((status & appApplyStatus.DELETED) === appApplyStatus.DELETED) {
      return styleClazz[0];
    }
    return '';
  },
  displayText(status) {
    status = parseInt(status);
    if ((status & appApplyStatus.STOP) === appApplyStatus.STOP) {
      return DisplayMapper.APP_APPLY_STATUS[appApplyStatus.STOP];
    }
    if ((status & appApplyStatus.FORMAL_AUTH_OVER) === appApplyStatus.FORMAL_AUTH_OVER) {
      return DisplayMapper.APP_APPLY_STATUS[appApplyStatus.FORMAL_AUTH_OVER];
    }
    if ((status & appApplyStatus.FORMAL_VERIFY_FAIL) === appApplyStatus.FORMAL_VERIFY_FAIL) {
      return DisplayMapper.APP_APPLY_STATUS[appApplyStatus.FORMAL_VERIFY_FAIL];
    }
    if ((status & appApplyStatus.FORMAL_VERIFY_SUCCESS) === appApplyStatus.FORMAL_VERIFY_SUCCESS) {
      return DisplayMapper.APP_APPLY_STATUS[appApplyStatus.FORMAL_VERIFY_SUCCESS];
    }
    if ((status & appApplyStatus.FORMAL_VERIFYING) === appApplyStatus.FORMAL_VERIFYING) {
      return DisplayMapper.APP_APPLY_STATUS[appApplyStatus.FORMAL_VERIFYING];
    }
    if ((status & appApplyStatus.AUTH_OVER) === appApplyStatus.AUTH_OVER) {
      return DisplayMapper.APP_APPLY_STATUS[appApplyStatus.AUTH_OVER];
    }
    if ((status & appApplyStatus.VERIFY_FAIL) === appApplyStatus.VERIFY_FAIL) {
      return DisplayMapper.APP_APPLY_STATUS[appApplyStatus.VERIFY_FAIL];
    }
    if ((status & appApplyStatus.VERIFY_SUCCESS) === appApplyStatus.VERIFY_SUCCESS) {
      return DisplayMapper.APP_APPLY_STATUS[appApplyStatus.VERIFY_SUCCESS];
    }
    if ((status & appApplyStatus.VERIFYING) === appApplyStatus.VERIFYING) {
      return DisplayMapper.APP_APPLY_STATUS[appApplyStatus.VERIFYING];
    }
    if ((status & appApplyStatus.DELETED) === appApplyStatus.DELETED) {
      return DisplayMapper.APP_APPLY_STATUS[appApplyStatus.DELETED];
    }
    return '';
  }
};



// WEBPACK FOOTER //
// ./src/common/applyStatusHelper/AppApplyStatusHelper.js